module.exports = __webpack_public_path__ + "img/bus.8c37b853.svg";